import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import router from 'next/router'

import { Button } from '@/components/buttons/Button'
import { useBreakpoints } from '@/utils/useBreakpoints'

import Landing0Image from 'assets/images/hero/landing-0-characters.png'

import styles from './MainHeroContent.module.scss'

export const MainHeroContent = () => {
  const t = useTranslations()
  const { from } = useBreakpoints()
  const objectPosition = from('tablet') ? '90% 10%' : '20% 50%'
  return (
    <>
      <div className={styles.ImageContainer}>
        <div className={styles.Image}>
          <Image
            src={Landing0Image}
            alt="hero-1"
            layout="fill"
            placeholder="blur"
            objectPosition={objectPosition}
            objectFit="cover"
            sizes="(max-width: 768px) 100vw, 50vw"
            quality="100"
          />
        </div>
        <div className={styles.OverlayBackground} />
      </div>
      <div className={styles.Background}>
        <div className={styles.Overlay}>
          <h1 className={styles.OverlayTitle}>{t('lan_hero_card1_title')}</h1>
          <h2 className={styles.OverlayDescription}>
            {t('lan_hero_card1_body')}
            &nbsp;
            <Link href="/help#guide">{t('lan_hero_button6')}</Link>
          </h2>
          <div className={styles.OverlayActionContainer}>
            <Button
              additionalClasses={styles.OverlayAction}
              onClick={() => router.push('/help#guide')}
              type="Secondary"
              content={t('lan_hero_button6')}
            />
          </div>
        </div>
      </div>
    </>
  )
}
